export default __webpack_public_path__ + "static/media/fasa.e7473ef8.svg";